import React from "react"

import {
  useI18next,
  Link,
  useTranslation,
} from "@zestia/gatsby-plugin-react-i18next"

import {
  SupportSearchBox,
  SupportSearchAutoCompleteResults,
} from "@/components/SupportSearchBox"
import { Configure } from "react-instantsearch"
import { AUTOCOMPLETE_RESULTS_PER_PAGE } from "@/utils/typesense-config"
import SupportSearchProvider from "@/components/SupportSearchProvider"

const SupportHeader = ({ children }) => {
  const { t } = useTranslation()
  const { originalPath, language } = useI18next()

  const isSupportHomePage = originalPath === "/support/"

  const indexName = `support-article-${language}`

  return (
    <section
      className={`support-header bg-shape bg-grey-1 ${
        isSupportHomePage
          ? "mt-0 mb-10 md:mb-16 pb-10 pt-10 md:pt-15 md:pb-10"
          : "mt-0 mb-10 md:mb-20 pb-10 pt-10 md:pt-0 md:pb-0"
      }`}
    >
      <div className="container-fluid">
        <div className="row center-xs">
          {!isSupportHomePage && (
            <div className="col-sm-3 support-header__desktop-col">
              <div className="row start-xs middle-xs height-100">
                <div className="col-sm-6">
                  <Link
                    className="text-link text-link--dark text-link--arrow-before"
                    to="/support"
                  >
                    {t("support.support-home")}
                  </Link>
                </div>
              </div>
            </div>
          )}

          <div
            className={`col-xs-12 ${
              isSupportHomePage ? "col-md-8" : "col-md-6"
            }`}
          >
            {isSupportHomePage && (
              <h1 className="h1">{t("support.how-can-we-help")}</h1>
            )}

            <div
              className={`support-header__search-box-container ${
                isSupportHomePage
                  ? "support-header__search-box-container--home"
                  : "support-header__search-box-container--other"
              }`}
            >
              {children ? (
                children
              ) : (
                <SupportSearchProvider
                  indexName={indexName}
                  useQueryParams={false}
                >
                  <Configure hitsPerPage={AUTOCOMPLETE_RESULTS_PER_PAGE} />

                  <SupportSearchBox
                    indexName={indexName}
                    searchAsYouType={true}
                  >
                    <SupportSearchAutoCompleteResults indexName={indexName} />
                  </SupportSearchBox>
                </SupportSearchProvider>
              )}
            </div>
          </div>

          {!isSupportHomePage && (
            <div className="col-sm-3 support-header__desktop-col"></div>
          )}
        </div>
      </div>
    </section>
  )
}

export default SupportHeader
